/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

/**
 * Renvoie un objet instancié
 * @param {string} className Le nom de la classe, il doit y avoir un fichier du même nom dans le dossier objets
 * @param {*} [...args] Les arguments à passer au constructeur
 * @returns {*} Objet de la classe className auquel on a filé les arguments qui suivent className
 * args doit être passé sous forme d'un Array (ou un paramètre)
 */
module.exports = function factory (className, args) {
  // cette syntaxe peut pas marcher
  // return new Constructor.apply(this, args)
  // mais on peut créer un nouveau constructeur sans argument qui renvoie le bon objet instancié
  // http://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
  // Il y a plus court et plus rapide : https://jsperf.com/dynamic-arguments-to-the-constructor
  try {
    const cnstor = require('../objets/' + className)
    return new (Function.prototype.bind.apply(cnstor, [null].concat(Array.prototype.slice.call(arguments, 1))));
  } catch (error) {
    console.error(error.stack)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/classes/objetFactory.js